import { render, staticRenderFns } from "./tiscFile.vue?vue&type=template&id=18fbcdaa&"
import script from "./tiscFile.vue?vue&type=script&lang=js&"
export * from "./tiscFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports